import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetAllTransactionsService = (page = 1, limit = 10) => {
  return HTTP_CLIENT.get(
    `${Endpoint.transactions.getAllTransactions}?page=${page}&limit=${limit}`
  );
};

const TransferPaymentService = (id: number) => {
  return HTTP_CLIENT.post(`${Endpoint.transactions.transferPayment}/${id}`);
};

export { GetAllTransactionsService, TransferPaymentService };
